import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CSidebar, CSidebarBrand, CSidebarNav } from '@coreui/react';

import logo from '../assets/images/logo4.png';
import { getCurrentUser } from '@aws-amplify/auth';
// import logo_mini from '../assets/images/logo_mini.png';

const TheSidebar = () => {
  const dispatch = useDispatch();
  const show = useSelector((state) => state.sidebarShow);
  const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        setCurrentUser(user);
      } catch (error) {
        setCurrentUser(null);
      }
    };
    fetchUser();
  }, []);

  return (
    <CSidebar show={show} onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}>
      <CSidebarBrand className="d-md-down-none sed-om-sidebar-brand" to="/">
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-full">
          <div className="logo">
            <img src={logo} alt="自然電力" style={{ width: '40%' }} />
          </div>
          <p className="site">機器制御型DR（EQ）</p>
          <p className="site">管理システム</p>
          {currentUser?.signInDetails?.['loginId'] && <p className="name">{currentUser?.signInDetails?.['loginId']}</p>}
        </div>
        <div className="sed-om-sidebar-logo-wrapper c-sidebar-brand-minimized">
          <div className="logo">
            <img src={logo} alt="自然電力" style={{ width: 40 }} />
          </div>
        </div>
      </CSidebarBrand>
      <CSidebarNav></CSidebarNav>
      {/* <CSidebarMinimizer className="c-d-md-down-none"/> */}
    </CSidebar>
  );
};

export default React.memo(TheSidebar);
